import "core-js/modules/es.array.push.js";
import { request } from "@/js/http/http_request";
import { getLoggedUserData, isAdminNotConsultant, isConsultantOrHolding, isUserBuyerGroup } from "@/js/http/auth";
import { getErrorData } from "@/js/forms.js";
import { inboundDeliveryOneClickActionTypes } from "@/js/lists.ts";
export default {
  name: "InboundOneClickAction",
  data: function data(_this) {
    return {
      loggedUserData: {},
      inboundDeliveryOneClickAction: {
        inboundDeliveryId: null,
        guid: null,
        reference: null
      },
      loading: {
        isLoading: false,
        isComplete: false,
        text: "Please wait a few moments."
      },
      errorMessage: "",
      clientData: {
        client_id: _this.$whitelabel.clientId,
        client_secret: _this.$whitelabel.clientSecret
      },
      inboundDeliveryOneClickActionTypes: inboundDeliveryOneClickActionTypes
    };
  },
  computed: {
    isRequestFinishedWithError: function isRequestFinishedWithError() {
      return !this.loading.isComplete && this.errorMessage;
    },
    isLogged: function isLogged() {
      var _this$loggedUserData;
      return +((_this$loggedUserData = this.loggedUserData) === null || _this$loggedUserData === void 0 ? void 0 : _this$loggedUserData.idUser) > 0;
    }
  },
  created: function created() {
    this.inboundDeliveryOneClickAction.guid = this.$route.params.guid;
    this.loggedUserData = getLoggedUserData();
    this.fetchOneClickAction();
  },
  methods: {
    fetchOneClickAction: function fetchOneClickAction() {
      var _this = this;
      _this.loading.isLoading = true;
      request("/v1/one-click-action/inbound/" + this.inboundDeliveryOneClickAction.guid, "post", _this.clientData, false, "api", null).then(function (resp) {
        _this.inboundDeliveryOneClickAction = resp.data.value;
        if (_this.inboundDeliveryOneClickAction.usageDate != null && _this.isAdminNotConsultant(_this.loggedUserData)) {
          _this.loading.text = "This link is not available anymore. You are redirected to the order page.";
          _this.goToInboundDeliveryDetails();
        } else {
          if (resp.data.value.type == inboundDeliveryOneClickActionTypes.CUSTOMER_APPROVE.id) {
            _this.loading.text = "Your order is updating, please wait a few moments.";
          } else {
            _this.loading.text = "We are cancelling your order, please wait a few moments.";
          }
          _this.updateOneClickAction();
        }
      }).catch(function (e) {
        _this.loading.isLoading = false;
        _this.manageErrors(e);
      });
    },
    updateOneClickAction: function updateOneClickAction() {
      var _this = this;
      request("/v1/one-click-action/inbound/" + this.inboundDeliveryOneClickAction.guid + "/update", "post", _this.clientData, false, "api").then(function (_) {
        _this.loading.isLoading = false;
        _this.loading.isComplete = true;
      }).catch(function (e) {
        _this.loading.isLoading = false;
        _this.manageErrors(e);
      });
    },
    goToInboundDeliveryDetails: function goToInboundDeliveryDetails() {
      if (this.isAdminNotConsultant(this.loggedUserData)) {
        this.$router.push({
          name: "adminInboundDeliveryDetails",
          params: {
            id: this.inboundDeliveryOneClickAction.inboundDeliveryId
          }
        });
      } else if (this.isConsultantOrHolding(this.loggedUserData)) {
        this.$router.push({
          name: "userInboundDeliveryDetails",
          params: {
            id: this.inboundDeliveryOneClickAction.inboundDeliveryId
          }
        });
      } else if (this.isUserBuyerGroup(this.loggedUserData)) {
        this.$router.push({
          name: "userInboundDeliveryDetails",
          params: {
            id: this.inboundDeliveryOneClickAction.inboundDeliveryId
          }
        });
      }
    },
    manageErrors: function manageErrors(e) {
      var _e$response;
      if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) === "guid_already_used") {
        if (this.isAdminNotConsultant(this.loggedUserData)) {
          this.goToInboundDeliveryDetails();
        } else {
          this.errorMessage = "This link is not available anymore.";
        }
        return;
      }
      var errorData = getErrorData(e, this.managedExceptions);
      this.$toasted.show(errorData.message, {
        type: errorData.type
      });
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isUserBuyerGroup: isUserBuyerGroup
  }
};